import { useState } from 'react';
import { Link } from 'react-router-dom';
import { resetPassword } from '../../lib/supabase';
import { useToast } from '../../components/Toast';

export function ForgotPassword() {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await resetPassword(email);

    if (error) {
      toast.error(error.message);
    } else {
      setSuccess(true);
    }
    setLoading(false);
  };

  if (success) {
    return (
      <>
        <div className="text-align-center">
          <h1 className="text-size-huge">Check your email</h1>
          <div className="spacer-tiny"></div>
          <div className="text-size-regular text-colour-alt-grey">
            We've sent a password reset link to <strong>{email}</strong>
          </div>
        </div>

        <div className="spacer-large"></div>

        <div className="auth-block">
          <div className="text-align-center">
            <Link to="/login" className="button is-wide is-large w-button">
              Back to login
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="text-align-center">
        <h1 className="text-size-huge">Forgot password?</h1>
        <div className="spacer-tiny"></div>
        <div className="text-size-regular text-colour-alt-grey">
          Enter your email and we'll send you a reset link
        </div>
      </div>

      <div className="spacer-large"></div>

      <div className="auth-block">
        <div className="account-block w-form">
          <form onSubmit={handleSubmit}>
            {/* Email Field */}
            <label htmlFor="email" className="form_label">
              Email
            </label>
            <input
              className="form_input is-light w-input"
              maxLength={256}
              name="email"
              placeholder="example@email.com"
              type="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />

            <div className="spacer-small"></div>

            {/* Submit Button */}
            <input
              type="submit"
              data-wait="Please wait..."
              className="button is-wide is-large w-button"
              value={loading ? 'Sending...' : 'Send reset link'}
              disabled={loading}
            />
          </form>
        </div>

        <div className="spacer-xsmall"></div>

        <div className="text-align-center">
          <Link to="/login" className="small-link">
            Back to login
          </Link>
        </div>
      </div>
    </>
  );
}
